import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

/* Local components */
import { ArbitrationComponent } from './arbitration.component';
import { ArbitrationHomeComponent } from './components/home/arbitration-home.component';
import { ArbitrationDepartmentComponent } from './components/department/arbitration-department.component';
import { ArbitrationCalendarComponent } from './components/calendar/arbitration-calendar.component';
import { ArbitrationRefereesComponent } from './components/referees/arbitration-referees.component';
import { ArbitrationAttachedComponent } from './components/attached/arbitration-attached.component';

/* Routes */
import { ArbitrationRoutingModule } from './arbitration-routing.module';

/* Interceptor */
import { Interceptor } from 'src/app/core/interceptors/http-request-interceptor';

import { ThemeModule } from 'src/app/@theme/theme.module';
import { ArbitrationEventsComponent } from './components/events/events.component';

@NgModule({
    declarations: [
        ArbitrationComponent,
        ArbitrationHomeComponent,
        ArbitrationDepartmentComponent,
        ArbitrationCalendarComponent,
        ArbitrationRefereesComponent,
        ArbitrationAttachedComponent,
        ArbitrationEventsComponent,
    ],
    imports: [CommonModule, RouterModule, ArbitrationRoutingModule, Interceptor, ThemeModule],
})
export class ArbitrationModule {}
